import { render, staticRenderFns } from "./BrandAuthorization.vue?vue&type=template&id=ac2297e4&scoped=true&"
import script from "./BrandAuthorization.vue?vue&type=script&lang=js&"
export * from "./BrandAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./BrandAuthorization.vue?vue&type=style&index=0&id=ac2297e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2297e4",
  null
  
)

export default component.exports